import { useSuspenseQuery } from "@tanstack/react-query";
import { Switch } from "@workspace/web-ui/components/switch";
import React, { useState } from "react";
import { useUpdateNotificationSettings } from "../api/mutations";
import { notificationValues } from "../api/queries/notification";

interface NotificationSettingsState {
  email: {
    appointment_reminders: boolean;
    prescription_refill_reminders: boolean;
  };
  sms: {
    appointment_reminders: boolean;
    prescription_refill_reminders: boolean;
  };
}

const NotificationSettings: React.FC = () => {
  const { mutate: sendNotificationUpdate } = useUpdateNotificationSettings();

  const notificationSettingsValue = useSuspenseQuery(notificationValues())

  console.log("notification",notificationSettingsValue.data?.settings.notifications.email.appointment_reminders);
     

  const [notifications, setNotifications] = useState<NotificationSettingsState>({
    email: {
      appointment_reminders: notificationSettingsValue.data?.settings?.notifications?.email?.appointment_reminders ?? false,
      prescription_refill_reminders: notificationSettingsValue.data?.settings?.notifications?.email?.prescription_refill_reminders ?? false,
    },
    sms: {
      appointment_reminders: notificationSettingsValue.data?.settings?.notifications?.sms?.appointment_reminders ?? false,
      prescription_refill_reminders: notificationSettingsValue.data?.settings?.notifications?.sms?.prescription_refill_reminders ?? false,
    },
  });

  const toggleNotification = (
    notificationType: keyof NotificationSettingsState,
    field: keyof NotificationSettingsState["email" | "sms"]
  ) => {
    const newValue = !notifications[notificationType][field];

    // Update the local state
    setNotifications((prev) => ({
      ...prev,
      [notificationType]: {
        ...prev[notificationType],
        [field]: newValue,
      },
    }));

    // Send the updated value to the endpoint
    sendNotificationUpdate({
      notification_type: notificationType,
      field,
      value: newValue,
    });
  };


  return (
    <div className="p-6 bg-white shadow-md rounded-lg lg:max-w-lg w-full">
      <div className="mb-5 space-y-4">
        <h3 className="text-xl font-medium mb-2">Email Notifications</h3>
        <div className="flex items-center justify-between mb-2">
          <span className="text-base">Appointment Reminders</span>
          <Switch
            checked={notifications.email.appointment_reminders}
            onCheckedChange={() =>
              toggleNotification("email", "appointment_reminders")
            }
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-base">Prescription Refill Reminders</span>
          <Switch
            checked={notifications.email.prescription_refill_reminders}
            onCheckedChange={() =>
              toggleNotification("email", "prescription_refill_reminders")
            }
          />
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-xl font-medium mb-2">SMS Notifications</h3>
        <div className="flex items-center justify-between mb-2">
          <span className="text-base">Appointment Reminders</span>
          <Switch
            checked={notifications.sms.appointment_reminders}
            onCheckedChange={() =>
              toggleNotification("sms", "appointment_reminders")
            }
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-base">Prescription Refill Reminders</span>
          <Switch
            checked={notifications.sms.prescription_refill_reminders}
            onCheckedChange={() =>
              toggleNotification("sms", "prescription_refill_reminders")
            }
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;